import React from "react";
import dayjs from "dayjs";

const ReusableTable = ({
  data = [],
  columns = [],
  className = "bg-white rounded-lg shadow-sm mt-2",
  onRowAction,
  currentUserAccessGroup,
  loadingPreCodeItemPresent = false,
}) => {
  const renderCellContent = (item, column) => {
    const value = column.accessor ? getNestedValue(item, column.accessor) : "";

    //  special rendering cases
    if (column.render) {
      return column.render(value, item);
    }

    //  Date formatting
    if (column.type === "date" && value) {
      return dayjs(value).format(column.dateFormat || "DD/MM/YYYY");
    }

    //  status with styling
    if (column.type === "status") {
      return (
        <span className={giveBackStageStyle ? giveBackStageStyle(value) : ""}>
          {value}
        </span>
      );
    }

    //  trimmed text
    if (column.trim && typeof value === "string") {
      return value.trim();
    }

    return value;
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((value, key) => value?.[key], obj);
  };

  const renderActionButtons = (item, column) => {
    if (!column.actions) return null;

    return (
      <div
        className={`flex ${
          column.actionLayout || "justify-center"
        } items-center gap-1`}
      >
        {column.actions.map((action, actionIndex) => {
          if (
            action.condition &&
            !action.condition(item, currentUserAccessGroup)
          ) {
            return null;
          }

          return (
            <button
              key={actionIndex}
              className={action.className}
              onClick={() => action.onClick(item)}
              disabled={action.disabled && action.disabled(item)}
            >
              {action.loading && action.loading(item)
                ? action.loadingText
                : action.label}
            </button>
          );
        })}
      </div>
    );
  };
  const giveBackStageStyle = (stage) => {
    switch (stage) {
      case "Approved":
        return "inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset";

      case "For Approval":
        return "inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset";

      case "Draft":
        return "inline-flex items-center rounded-md bg-yellow-500 px-2 py-1 text-xs font-medium text-white ring-1 ring-gray-500/10 ring-inset";

      case "Customer Submission & Awaiting Approval":
        return "inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-yellow-600/20 ring-inset";

      case "Customer Submission":
        return "inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-yellow-600/20 ring-inset";

      case "Won -Sales Order":
        return "inline-flex items-center rounded-md bg-green-500 px-2 py-1 text-xs font-medium text-green-50 ";
      case "Lost-Customer Rejection":
        return "inline-flex items-center rounded-md bg-red-500 px-2 py-1 text-xs font-medium text-red-50";
      case "Lost-Customer REjection":
        return "inline-flex items-center rounded-md bg-red-500 px-2 py-1 text-xs font-medium text-red-50";

      default:
        return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";
    }
  };
  return (
    <div className={className}>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-gray-200 text-gray-600 text-sm">
            {columns.map((column, index) => (
              <th key={index} className={`p-1 ${column.headerClassName || ""}`}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index} className="border-b text-sm hover:bg-gray-50">
              {columns.map((column, colIndex) => (
                <td
                  key={colIndex}
                  className={`p-1 ${column.cellClassName || ""}`}
                >
                  {column.type === "actions"
                    ? renderActionButtons(item, column)
                    : renderCellContent(item, column)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {data?.length === 0 ? <span>No Data Found</span> : ""}
    </div>
  );
};

export default ReusableTable;
